import { useState } from 'react';
import PropTypes from 'prop-types';

import FormManager from './';

function useFormManager(formConfig, data) {
	// noinspection JSUnusedLocalSymbols
	var _useState = useState(0),
	    rev = _useState[0],
	    setRevision = _useState[1]; // eslint-disable-line


	var _useState2 = useState(function () {
		return FormManager(setRevision, formConfig, data);
	}),
	    formManager = _useState2[0];

	return formManager;
}

var object = PropTypes.object;


useFormManager.propTypes = {
	formConfig: object,
	data: object
};

export default useFormManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/useFormManager.js
// module id = 544
// module chunks = 0